/**
 * This file contains all the possible mutations that can be commited to the store.
 */

 // Skeleton information manipulation
 export const SET_SELECTED_TECHNOLOGY = 'SET_SELECTED_TECHNOLOGY';
 export const SET_SELECTED_ARCHITECTURE = 'SET_SELECTED_ARCHITECTURE';
 export const CLEAR_SELECTED_TECHNOLOGY = 'CLEAR_SELECTED_TECHNOLOGY';
 export const CLEAR_SELECTED_ARCHITECTURE = 'CLEAR_SELECTED_ARCHITECTURE';
 
 // Dashboard mutations
 export const SET_SELECTED_APP = 'SET_SELECTED_APP';
 export const CLEAR_SELECTED_APP = 'CLEAR_SELECTED_APP';
 export const SET_APPS = 'SET_APPS';
 export const REMOVE_APP = 'REMOVE_APP';

 // Template building mutations
 export const SET_VIEWS = 'SET_VIEWS';
 export const CLEAR_VIEWS = 'CLEAR_VIEWS';
 export const ADD_VIEW = 'ADD_VIEW';
 export const SET_ADDED_VIEWTYPE = 'SET_ADDED_VIEWTYPE';
 export const RESET_VIEWS_START = 'RESET_VIEWS_START';

 // Footer state mutations
 export const SET_FOOTER_STATE = "SET_FOOTER_STATE";

 // User mutations
 export const SET_USER = "SET_USER";

 // Navigation Bar mutations
 export const SET_NAVIGATION_BAR_STATE = "SET_NAVIGATION_BAR_STATE";